module.exports = __webpack_public_path__ + "assets/img/lm_avatar.fff5a1ae.png";